/** @format */

export const ROUTES = {
	HOME: '/',
	LOGIN: '/login',
	REGISTER: '/register',
	FORGOT_PASSWORD: '/forgot-password',
	OTP: '/verify-otp',
	BLOGS: '/blogs',
	BLOG_DETAILS: (slug: string) => `/blogs/${slug}`,
	MENTORS: '/mentors',
	CREATE_NEW_PASSWORD: '/create-password',
	RESET_PASSWORD: '/reset-password',
	DASHBOARD: '/dashboard',
	DASHBOARD_ANSWER: (questionId: string | number) => `/dashboard/${questionId}`,
	SUBJECT: '/subject',
	ALL_SUBJECTS: '/law-subjects',
	SUBJECT_DETAIL: (slug: string) => `/law-subjects/${slug}`,
	PROFILE: '/profile',
	ADMIN_DASHBOARD: '/admin/dashboard',
	CHECKOUT: '/subject/checkout',
	CHECKOUT_SUCCESS: '/checkout/success',
	// Super Admin Routes
	SUPERADMIN_DASHBOARD: '/superadmin/dashboard',
	CREATE_ADMIN_USER: '/superadmin/create-admin-user',
	SUPERADMIN_STUDENTS: '/superadmin/students',
	SUPERADMIN_PROFILE: '/superadmin/profile',

	// Admin Routes
	CREATE_BLOG_POST: '/admin/create-blog-post',
	ALL_BLOG_POSTS: '/admin/all-blog-posts',
	EDIT_BLOG_POST: '/admin/edit-blog/:slug',
	ADMIN_PROFILE: '/admin/profile',

	// Other Routes
	CONTACT_US: '/contactus',
	REFUND_POLICY: '/refund_policy',
	TERMS_AND_CONDITIONS: '/terms_conditions',
	DISCLAIMER: '/disclaimer',
	PRIVACY_POLICY: '/privacy_policy',
	SHIPPING_POLICY: '/shipping_policy',
};
